import React from 'react';
import { Shield, Truck, Star, Award, CreditCard, MapPin } from 'lucide-react';
export function TrustBar() {
  const trustSignals = [{
    icon: Shield,
    text: 'Licensed & Insured'
  }, {
    icon: Truck,
    text: 'USDOT Registered'
  }, {
    icon: Star,
    text: '4.8★ from 500+ Reviews'
  }, {
    icon: Award,
    text: '20+ Years Experience'
  }, {
    icon: CreditCard,
    text: 'No Upfront Payment'
  }];
  return <div className="bg-brand-navy-light text-white py-6 border-b-4 border-brand-red" data-id="element-293">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-294">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 text-center" data-id="element-295">
          {trustSignals.map((signal, index) => <div key={index} className="flex flex-col items-center justify-center gap-2" data-id="element-296">
              <signal.icon className="w-6 h-6 text-brand-red" data-id="element-297" />
              <span className="text-sm font-semibold text-slate-200" data-id="element-298">
                {signal.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}